<template>
  <div class="author-index">
    <div class="top-line">
      <div
        class="small-button"
        style="margin-right: 20px"
        @click="navigateBack"
      >
        返回
      </div>
      <span class="title">ta的主页</span>
    </div>
    <div class="main-content">
      <div class="left-content">
        <img class="avatar" :src="userInfo.avatar || require('../../../images/teacherCover.png')" alt="" />
        <div class="user-name">{{ userInfo.nick_name }}</div>
        <div class="school-name">{{ userInfo.school.name }}</div>
        <div
          v-if="role !== 'admin' && uid != myUid"
          class="follow-button"
          @click="toFollow"
        >
          {{ userInfo.is_follow ? '取关' : '关注' }}
        </div>
      </div>
      <div class="right-content">
        <div class="top-tag">已发布作品</div>
        <el-table
          :data="data"
          style="width: 100%; margin-bottom: 20px"
          height="calc(100vh - 375px)"
        >
          <el-table-column label="序号" width="80" align="center">
            <template slot-scope="scope">{{
              scope.$index + 1 + (page - 1) * 10
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="资源标题"
          ></el-table-column>
          <el-table-column label="资源标签" width="width" align="center">
            <template slot-scope="scope">{{
              scope.row.tag ? scope.row.tag.join(',') : ''
            }}</template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="文件类型"
            width="width"
            align="center"
          >
            <template slot-scope="scope">{{
              getFileType(scope.row.urls)
            }}</template>
          </el-table-column>
          <el-table-column label="浏览/收藏/下载" width="200" align="center">
            <template slot-scope="scope">
              <div class="data">
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 17px; height: 12px"
                    :src="require('../../assets/view.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.views || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 15px; height: 14px"
                    :src="require('../../assets/collect.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.collect || 0) }}
                </div>
                <div class="data-item">
                  <img
                    class="data-icon"
                    style="width: 14px; height: 14px"
                    :src="require('../../assets/download.png')"
                    alt=""
                  />
                  {{ getDisplayCount(scope.row.download || 0) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <div style="display: flex; justify-content: center">
                <div style="display: flex; justify-content: center">
                  <div class="small-button" @click="toDetail(scope.row.id)">
                    查看
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="onPageChange"
          :current-page="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          background
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, getUserResource, follow } from '@/api/api'
import { getFileType } from '../../utils/utils'
export default {
  name: 'AuthorIndex',
  data: () => ({
    userInfo: { school: {} },
    data: [],
    page: 1,
    total: 0,
    uid: 0,
    myUid: 0,
    role: '',
  }),
  mounted() {
    let user = JSON.parse(localStorage.getItem('yey-user'))
    this.myUid = user.id
    this.role = user.role
    this.uid = this.$route.query.id
    getUserInfo(this.uid).then((res) => {
      console.log('res', res)
      this.userInfo = res.data.data || { school: {} }
    })
    this.search()
  },
  beforeRouteLeave(to, from, next) {
    to.meta.keepAlive = true
    next(0)
  },
  methods: {
    getFileType,
    navigateBack() {
      this.$router.back()
    },
    search() {
      getUserResource(this.uid, this.page).then((res) => {
        console.log('resource', res)
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },
    onPageChange(e) {
      this.page = e
      this.search()
    },
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    toDetail(id) {
      this.$router.push(`bookResource?id=${id}`)
    },
    toFollow() {
      let yeyDetail = JSON.parse(sessionStorage.getItem('yey-detail'))
      if(this.userInfo.id == yeyDetail.created_by) {
        yeyDetail.follow = this.userInfo.is_follow ? false : true
        sessionStorage.setItem('yey-detail', JSON.stringify(yeyDetail))
      }
      follow(this.userInfo.id).then((res) => {
        if (this.userInfo.is_follow) {
          this.$message({
            message: '取消关注成功！',
            type: 'success',
          })
          this.$set(this.userInfo, 'is_follow', false)
        } else {
          this.$message({
            message: '关注成功！',
            type: 'success',
          })
          this.$set(this.userInfo, 'is_follow', true)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.author-index {
  padding: 0 40px 40px;
  .top-line {
    display: flex;
    height: 81px;
    align-items: center;
  }
  .small-button {
    width: 56px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid #00aeff;
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #00aeff;
    user-select: none;
    cursor: pointer;
  }
  .title {
    font-size: 18px;
    color: #4d4d4d;
    margin-left: 20px;
  }
  .main-content {
    display: flex;
    .left-content {
      width: 220px;
      height: calc(100vh - 221px);
      background-color: #fff;
    }
    .right-content {
      box-sizing: border-box;
      width: 100%;
      height: calc(100vh - 221px);
      padding: 20px;
      margin-left: 20px;
      background-color: #fff;
      overflow-y: auto;
    }
  }
  .avatar {
    display: block;
    width: 112px;
    height: 112px;
    border-radius: 50%;
    margin: 19px auto 14px;
  }
  .user-name {
    text-align: center;
    font-size: 20px;
    color: #1a1a1a;
  }
  .school-name {
    text-align: center;
    font-size: 14px;
    color: #808080;
  }
  .follow-button {
    width: 84px;
    height: 34px;
    line-height: 34px;
    margin: 25px auto 0;
    background: #10b3ff;
    border-radius: 17px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    user-select: none;
  }
  .top-tag {
    width: 101px;
    height: 40px;
    margin-bottom: 20px;
    line-height: 40px;
    background: rgba(39, 178, 254, 0.1);
    border-radius: 4px;
    border: 1px solid #d6f1ff;
    text-align: center;
    font-size: 14px;
    color: #333;
  }
  .data {
    display: flex;
    justify-content: center;
    align-items: center;
    .data-item {
      margin-right: 29px;
      font-size: 14px;
      color: #4c4c4c;
      &:last-child {
        margin-right: 0;
      }
      .data-icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
